import { useGetResourceLabel, useResourceContext } from "react-admin";
import { useAutovioContext } from "../hooks/useAutovioContext";
import { Button } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

export function BackButton(
  props: { onClick?: () => void; url?: never; children?: string } | { onClick?: never; url: string; children: string },
) {
  const { onClick, url, children } = props;
  const [{ drivingSchoolId }] = useAutovioContext();
  const resource = useResourceContext();
  const getResourceLabel = useGetResourceLabel();

  return (
    <Button
      sx={{
        padding: "10px",
        borderRadius: "20px",
        minHeight: "32px",
        height: "32px",
        textTransform: "none",
        "&:hover": {
          backgroundColor: "action.hover",
        },
        marginLeft: "-10px !important",
        fontSize: "15px",
        "& .MuiButton-startIcon": { marginRight: 0 },
      }}
      startIcon={<NavigateBeforeIcon sx={{ width: "20px", height: "20px" }} />}
      onClick={
        onClick ??
        ((event) => {
          event.stopPropagation();
          event.preventDefault();
          if (url) {
            browserHistory.replace(url);
          } else if (resource) {
            browserHistory.replace(drivingSchoolId ? `/drivingSchools/${drivingSchoolId}/${resource}` : `/${resource}`);
          } else {
            browserHistory.go(-1);
          }
        })
      }
      data-testid="back-button"
    >
      {children ?? (resource ? getResourceLabel(resource) : "Zurück")}
    </Button>
  );
}
